import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const reinviteRecipientApi = (wireId: string): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/organization/wires/${wireId}/recipient/reinvite/`;

  return authApiService.POST(uri, {});
};
